function buildPdetails() {

  let qBuild = `
    <fieldset>
      <legend>
        <h1>${trans(screenType + '.0')}</h1>
      </legend>
      <div id="pName" style="display:none">
        <p>
          <label for="name">${trans(screenType + '.1')}</label><br/>
          <input type="text" id="name" autofocus required/>
        </p>
      </div>
      <div id="pAge" style="display:none">
        <p>
          <label for="age">${trans(screenType + '.2')}</label><br/>
          <input type = "number" id="age" required min="1" max="99"/>
        </p>
      </div>
      <div id="pSex" style="display:none">
        <p>
          ${trans(screenType + '.3.0')}<br/>
          <input type="radio" name="sex" id="sex_male" value="m" required>
          <label for="sex_male">${trans(screenType + '.3.1')}</label>
          <input type="radio" name="sex" id="sex_female" value="f" required>
          <label for="sex_female">${trans(screenType + '.3.2')}</label>
          <input type="radio" name="sex" id="sex_other" value="o" required>
          <label for="sex_other">${trans(screenType + '.3.3')}</label>
        </p>
      </div>
      <div id="pSexAssigned" style="display:none">
        <p>
          ${trans(screenType + '.11.0')}<br/>
          <input type="radio" name="sex_assigned" id="sex_assigned_male" value="m" required>
          <label for="sex_assigned_male">${trans(screenType + '.11.1')}</label>
          <input type="radio" name="sex_assigned" id="sex_assigned_female" value="f" required>
          <label for="sex_assigned_female">${trans(screenType + '.11.2')}</label>
        </p>
      </div>
      <div id="pEducation" style="display:none">
        <p>
          <label for="education"> ${trans(screenType + '.4.0')} </label><br/>
          <select name="education" id = "education" style="font-size: 1em" required>
            <option value="">${trans(screenType + '.4.1')}</option>
            <option value="${trans(screenType + '.4.2', 'english')}">${trans(screenType + '.4.2')}</option>
            <option value="${trans(screenType + '.4.3', 'english')}">${trans(screenType + '.4.3')}</option>
            <option value="${trans(screenType + '.4.4', 'english')}">${trans(screenType + '.4.4')}</option>
            <option value="${trans(screenType + '.4.5', 'english')}">${trans(screenType + '.4.5')}</option>
            <option value="${trans(screenType + '.4.6', 'english')}">${trans(screenType + '.4.6')}</option>
          </select>
        </p>
      </div>
      <div id="pHandedness" style="display:none">
        <p>
          ${trans(screenType + '.5.0')}<br>
          <input type="radio" name="handedness" id="hand_right" value="r" required>
          <label for="hand_right">${trans(screenType + '.5.1')}</label>&nbsp&nbsp
          <input type="radio" name="handedness" id="hand_left" value="l" required>
          <label for="hand_left">${trans(screenType + '.5.2')}</label>&nbsp&nbsp
          <input type="radio" name="handedness" id="hand_ambi" value="a" required>
          <label for="hand_ambi">${trans(screenType + '.5.3')}</label>
        </p>
      </div>
      <div id="pSexualOrientation" style="display:none">
        <p>
          <label for="sexual_orientation">${trans(screenType + '.6.0')}</label><br/>
          <select name="sexual_orientation" id = "sexual_orientation" style="font-size: 1em" required>
            <option value="">${trans(screenType + '.6.1')}</option>
            <option value="${trans(screenType + '.6.2', 'english')}">${trans(screenType + '.6.2')}</option>
            <option value="${trans(screenType + '.6.3', 'english')}">${trans(screenType + '.6.3')}</option>
            <option value="${trans(screenType + '.6.4', 'english')}">${trans(screenType + '.6.4')}</option>
            <option value="${trans(screenType + '.6.5', 'english')}">${trans(screenType + '.6.5')}</option>
          </select>
        </p>
      </div>
      <div id="pEthnicity" style="display:none">
        <p>
          <label for="ethnicity">${trans(screenType + '.7.0')}</label><br/>
          <select name="ethnicity" id = "ethnicity" style="font-size: 1em" required>
            <option value="">${trans(screenType + '.7.1')}</option>
            <option value="${trans(screenType + '.7.2', 'english')}">${trans(screenType + '.7.2')}</option>
            <option value="${trans(screenType + '.7.3', 'english')}">${trans(screenType + '.7.3')}</option>
            <option value="${trans(screenType + '.7.4', 'english')}">${trans(screenType + '.7.4')}</option>
            <option value="${trans(screenType + '.7.5', 'english')}">${trans(screenType + '.7.5')}</option>
            <option value="${trans(screenType + '.7.6', 'english')}">${trans(screenType + '.7.6')}</option>
            <option value="${trans(screenType + '.7.7', 'english')}">${trans(screenType + '.7.7')}</option>
            <option value="${trans(screenType + '.7.8', 'english')}">${trans(screenType + '.7.8')}</option>
          </select>
        </p>
      </div>
      <div id="pNationality" style="display:none">
        <p>
          <label for="nationality">${trans(screenType + '.8')}</label><br/>
          <input type="text" id="nationality" required/>
        </p>
      </div>
      <div id="pOther1" style="display:none">
        <p>
          <label for="other1" id="other1_label">Other1:</label><br>
          <input type="text" id="other1" required/>
        </p>
      </div>
      <div id="pOther2" style="display:none">
        <p>
          <label for="other2" id="other2_label">Other2:</label><br>
          <input type="text" id="other2" required/>
        </p>
      </div> 
      <div id="pOther3" style="display:none">
        <p>
          <label for="other3" id="other3_label">Other3:</label><br>
          <input type="text" id="other3" required/>
        </p>
      </div>
      <div id="pOther4" style="display:none">
        <p>
          <label for="other4" id="other4_label">Other4:</label><br>
          <input type="text" id="other4" required/>
        </p>
      </div>        
      <div id="pOther5" style="display:none">
        <p>
          <label for="other5" id="other5_label">Other5:</label><br>
          <input type="text" id="other5" required/>
        </p>
      </div>    
      <div id="check" style="display:block;"></div>
      <p></p>    
      <div id="alertText" style="color:#e0005a"></div>
      <br/>
    </fieldset>
  `
  // append generated table to the div container for form trials
  // $('#displayScreen').append(qBuild);
  $('#P_details').append(qBuild);

}

function showPdetails()
{
  screenType = "pdetails";

  buildPdetails();

  if (participant_name=="on"){document.getElementById("pName").style.display="block";}
  if (participant_age=="on"){document.getElementById("pAge").style.display="block";}
  if (participant_sex=="on"){document.getElementById("pSex").style.display="block";}
  if (participant_sex_assigned_at_birth=="on"){document.getElementById("pSexAssigned").style.display="block";}
  if (participant_education=="on"){document.getElementById("pEducation").style.display="block";}
  if (participant_handedness=="on"){document.getElementById("pHandedness").style.display="block";}
  if (participant_sexual_orientation=="on"){document.getElementById("pSexualOrientation").style.display="block";}
  if (participant_nationality=="on"){document.getElementById("pNationality").style.display="block";}
  if (participant_ethnicity=="on"){document.getElementById("pEthnicity").style.display="block";}
  if (participant_other1=="on"){document.getElementById("other1_label").innerHTML=participant_other1_label;document.getElementById("pOther1").style.display="block";}
  if (participant_other2=="on"){document.getElementById("other2_label").innerHTML=participant_other2_label;document.getElementById("pOther2").style.display="block";}
  if (participant_other3=="on"){document.getElementById("other3_label").innerHTML=participant_other3_label;document.getElementById("pOther3").style.display="block";}
  if (participant_other4=="on"){document.getElementById("other4_label").innerHTML=participant_other4_label;document.getElementById("pOther4").style.display="block";}
  if (participant_other5=="on"){document.getElementById("other5_label").innerHTML=participant_other5_label;document.getElementById("pOther5").style.display="block";}


  show("P_details");

  showOneButtonStandard(trans("pdetails.10"));

  alignParticipantInformationButton();
}

function endPdetails()
{

document.getElementById("alertText").innerHTML=="";
var infoMissing = 0;

var x1=document.forms["P_details"]["name"].value;
var x2=document.forms["P_details"]["age"].value;
var x3m=document.forms["P_details"]["sex_male"].checked;
var x3f=document.forms["P_details"]["sex_female"].checked;
var x3o=document.forms["P_details"]["sex_other"].checked;
var x4=document.forms["P_details"]["education"].value;
var x5r=document.forms["P_details"]["hand_right"].checked;
var x5l=document.forms["P_details"]["hand_left"].checked;
var x5a=document.forms["P_details"]["hand_ambi"].checked;
var x11=document.forms["P_details"]["sexual_orientation"].value;
var x12=document.forms["P_details"]["ethnicity"].value;
var x13=document.forms["P_details"]["nationality"].value;
var x6=document.forms["P_details"]["other1"].value;
var x7=document.forms["P_details"]["other2"].value;
var x8=document.forms["P_details"]["other3"].value;
var x9=document.forms["P_details"]["other4"].value;
var x10=document.forms["P_details"]["other5"].value;
let x11m = document.forms['P_details']['sex_assigned_male'].checked
let x11f = document.forms['P_details']['sex_assigned_female'].checked

if(participant_mandatory_fields === "1") {
  if (participant_other5=="on" && (x10==null || x10=="")){document.getElementById("alertText").innerHTML=participant_other5_label+trans(screenType + '.9.9');infoMissing=1;}
  if (participant_other4=="on" && (x9==null || x9=="")){document.getElementById("alertText").innerHTML=participant_other4_label+trans(screenType + '.9.9');infoMissing=1;}
  if (participant_other3=="on" && (x8==null || x8=="")){document.getElementById("alertText").innerHTML=participant_other3_label+trans(screenType + '.9.9');infoMissing=1;}
  if (participant_other2=="on" && (x7==null || x7=="")){document.getElementById("alertText").innerHTML=participant_other2_label+trans(screenType + '.9.9');infoMissing=1;}
  if (participant_other1=="on" && (x6==null || x6=="")){document.getElementById("alertText").innerHTML=participant_other1_label+trans(screenType + '.9.9');infoMissing=1;}
  if (participant_nationality=="on" && (x13==null || x13=="")){document.getElementById("alertText").innerHTML=trans(screenType + '.9.8');infoMissing=1;}
  if (participant_ethnicity=="on" && (x12==null || x12=="")){document.getElementById("alertText").innerHTML=trans(screenType + '.9.7');infoMissing=1;}
  if (participant_sexual_orientation=="on" && (x11==null || x11=="")){document.getElementById("alertText").innerHTML=trans(screenType + '.9.6');infoMissing=1;}
  if (participant_handedness=="on" && (x5r==0 && x5l==0 && x5a==0)){document.getElementById("alertText").innerHTML=trans(screenType + '.9.5');infoMissing=1;}
  if (participant_education=="on" && (x4==null || x4=="")){document.getElementById("alertText").innerHTML=trans(screenType + '.9.4');infoMissing=1;}
  if (participant_sex=="on" && (x3m==0 && x3f==0 && x3o==0)){document.getElementById("alertText").innerHTML=trans(screenType + '.9.3');infoMissing=1;}
  if (participant_sex_assigned_at_birth=="on" && (x11m==0 && x11f==0)){document.getElementById("alertText").innerHTML=trans(screenType + '.9.10');infoMissing=1;}
  if (participant_age=="on" && (x2>99  || (x2<18 && allow_under_18!="on"))){document.getElementById("alertText").innerHTML=trans(screenType + '.9.2');infoMissing=1;}
  if (participant_age=="on" && (x2==null || x2=="")){document.getElementById("alertText").innerHTML=trans(screenType + '.9.1');infoMissing=1;}
  if (participant_name=="on" && (x1==null || x1=="")){document.getElementById("alertText").innerHTML=trans(screenType + '.9.0');infoMissing=1;}
}

var gender = 'other';
// if (!(x5r==0 && x5l==0)&&!(x4==null || x4=="")&&!(x3m==0 && x3f==0 && x3o==0)&&!((x2<18 && allow_under_18!="on")|| x2>99)&&!(x2==null || x2=="")&&!(x1==null || x1==""))
if (!infoMissing)
{
  if (participant_name=="on")
  {
    saveInfoColumns.push('id');
    saveInfo.push(x1);
  }
  if (participant_age=="on")
  {
    saveInfoColumns.push('age');
    saveInfo.push(x2);
  }
  if (participant_sex=="on")
  {
    saveInfoColumns.push('gender');
    if (x3f){saveInfo.push("woman"); gender = 'woman';}
    else if (x3m){saveInfo.push("man"); gender = 'man';}
    else if (x3o){saveInfo.push("other");}
    else {
        saveInfo.push('');
    }
  }
  if (participant_sex_assigned_at_birth=="on")
  {
    saveInfoColumns.push('sex_assigned_at_birth');
    if (x11f){saveInfo.push("female"); sex_assigned_at_birth = 'female';}
    else if (x11m){saveInfo.push("male"); sex_assigned_at_birth = 'male';}
    else {
        saveInfo.push('');
    }
  }
  if (participant_education=="on")
  {
    saveInfoColumns.push('education');
    saveInfo.push(x4);
  }
  if (participant_handedness=="on")
  {
    saveInfoColumns.push('handedness');
    if (x5l){saveInfo.push("left-handed");}
    else if (x5r){saveInfo.push("right-handed");}
    else if (x5a){saveInfo.push("ambidextrous");}
    else {
        saveInfo.push('');
    }
  }
  if (participant_sexual_orientation=="on")
  {
    saveInfoColumns.push('sexual orientation');
    saveInfo.push(x11);
  }
  if (participant_ethnicity=="on")
  {
    saveInfoColumns.push('ethnicity');
    saveInfo.push(x12);
  }
  if (participant_nationality=="on")
  {
    saveInfoColumns.push('nationality');
    saveInfo.push(x13);
  }
  if (participant_other1=="on")
  {
    saveInfoColumns.push(window.prepField(participant_other1_label));
    saveInfo.push(x6);
  }
  if (participant_other2=="on")
  {
    saveInfoColumns.push(window.prepField(participant_other2_label));
    saveInfo.push(x7);
  }
  if (participant_other3=="on")
  {
    saveInfoColumns.push(window.prepField(participant_other3_label));
    saveInfo.push(x8);
  }
  if (participant_other4=="on")
  {
    saveInfoColumns.push(window.prepField(participant_other4_label));
    saveInfo.push(x9);
  }
  if (participant_other5=="on")
  {
    saveInfoColumns.push(window.prepField(participant_other5_label));
    saveInfo.push(x10);
  }

    screen_pdetails="na";
    window.screen_pdetails_was_visible = true;
    hide("P_details");
    hide("button1");

    //trigger personal details are done
    testableTriggerEvent(window.events.doneExperimentSetup, {
      name: x1,
      age: x2,
      gender: gender
    });

    main();
  }
}